import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { EntityLink } from "scmp-app/components/entity-link";
import ScmpLogoFlag from "scmp-app/components/home/header/icon-logo.svg";

export const Container = styled.header`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  padding-block: 20px;
  padding-inline: 0;
  border-block-end: 1px solid #000000;
`;

export const Source = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column;

  margin-inline-start: 20px;
  padding-inline-start: 20px;

  color: #000000;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 12.9px;

  border-inline-start: 1px solid #000000;
`;

export const SourceText = styled.span`
  font-weight: 700;
`;

export const StyledScmpLogoFlag = styled(ScmpLogoFlag)`
  inline-size: 241px;
  block-size: 25px;
`;

export const StyledEntityLink = styled(EntityLink)`
  text-decoration: underline;
`;
